import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../../../../Icon';
import PrivacyIcon from '../../../../../PrivacyIcon';
import { formatDate } from '../../../../utils';
import styles from '../index.styl';

const ConditionCard = ({ entity }) => {
  const { name, startDate, isPrivate } = entity;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.leftSideWrapper}>
          <Icon
            size={28}
            name="icon-conditions-black"
            className={styles.iconType}
          />
          <div className={styles.contentWrapper}>
            <div className={cn(styles.title, styles.cropConditionsTitle)}>
              <div
                className={cn(styles.titleWrapper, { [styles.noTitle]: !name })}
              >
                {name}
              </div>
              <PrivacyIcon show={isPrivate} className={styles.privacyIcon} />
            </div>
            <div className={styles.description}>
              {startDate ? formatDate(startDate, 'MMM D, Y') : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ConditionCard.propTypes = {
  entity: PropTypes.object,
};

export default ConditionCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/ConditionCard/index.jsx